module.exports = __webpack_public_path__ + "img/azuread-black.df47a4be.svg";